import * as React from "react";
const SvgFiRrRaygun = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-raygun_svg__a)">
      <path
        fill="#062147"
        d="M22.557 5.292c-.664.767-1.532 1.632-2.557 2.333V4a1 1 0 1 0-2 0v4h-2V4.062c0-.913-.395-1.77-1.083-2.356a2.93 2.93 0 0 0-2.374-.667 32 32 0 0 0-4.22 1C6.277.72 3.503.151.855.001.176-.037-.237.731.148 1.291c.57.828 1.948 2.057 2.28 3.575C.968 5.992 0 7.366 0 9c0 1.624.956 2.99 2.4 4.113L.136 19.536a3.47 3.47 0 0 0 .572 3.071A3.47 3.47 0 0 0 3.503 24c1.585 0 2.978-1.07 3.366-2.539l1.823-5.387a32 32 0 0 0 3.852.888q.233.038.47.038c.69 0 1.364-.247 1.904-.705a3.08 3.08 0 0 0 1.083-2.356v-3.938h2v4a1 1 0 1 0 2 0v-3.645c1.027.696 1.892 1.557 2.553 2.326.53.615 1.447.206 1.447-.65V5.948c0-.854-.914-1.266-1.443-.655m-17.6 15.592A1.504 1.504 0 0 1 3.503 22c-.476 0-.913-.218-1.199-.598s-.375-.859-.264-1.259l2.085-5.91c.834.456 1.741.858 2.67 1.207zM14 13.94c0 .325-.138.63-.377.832a.92.92 0 0 1-.756.217C8.355 14.25 2 11.904 2 9.001s6.354-5.25 10.866-5.988a.94.94 0 0 1 .756.216c.24.203.377.507.377.832z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-raygun_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRaygun;
